<template>

  <div v-if="this.$route.path == '/' || this.$route.path == '/home'"  dir="rtl">
    <router-view />
  </div>
  <!-- App -->
  <div v-if="this.$route.path !== '/login' && this.$route.path !== '/' && this.$route.path !== '/home'" class="flex bg-packed font-lexend dark:bg-gray-900" dir="rtl">
    <div
      id="sidebar-scroll"
      class="min-h-screen text-gray-900 bg-gray-100 dark:bg-dark-bg dark:text-gray-100"
    >
      <Sidebar />
    </div>
    <div class="flex-auto w-full overflow-auto h-screen" id="body-scroll">
      <Header />
      <router-view />
      <!--<Footer />-->
    </div>
  </div>
  <!-- end app -->
  <div v-if="this.$route.path == '/login'"  dir="rtl">
    <router-view />
  </div>
  <vue-progress-bar></vue-progress-bar>
</template>

<script>
import Sidebar from "@/components/Navigation/Sidebar";
import Header from "@/components/Navigation/Header";
export default {
  name: "App",

  components: {
    Header,
    Sidebar,
  },
  mounted() {
   
  },
  };
</script>
<style>
@font-face {
  font-family: 'iransans';
  src: url('assets/font/iran_sans.ttf');
}

* {
  -webkit-tap-highlight-color: transparent;
}

html, body {
  font-family: 'iransans' !important;
  direction: rtl;
  @apply bg-gray-800 text-gray-800
}

.router-link-active {
  @apply text-yellow-500
}

select:invalid {
  color: gray
}

/* Hide scrollbar for Chrome, Safari and Opera */
.no-scrollbar::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.no-scrollbar {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}

.slide-enter-from {
  transform: translate(100%, 0);
}

.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>
